import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SearchIcon from "@mui/icons-material/Search";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Divider,
    Grid,
    TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useLoaderData } from "react-router-dom";
import { toast } from "react-toastify";

import DefaultApiService from "../../../../../infrastructure/api/default";
import useCheckPermission from "../../../../common/hooks/useCheckPermission";
import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import DropdownPicker from "../../../../components/shared/dropdown";
import ReportDataShow from "../../../../components/shared/report/ReportDataShow";

const initialValues = {
  SearchKind: "NoFilter",
  SearchText: "",
};

const StationSearchPage = () => {
  const pageInfo = useGetPageInfo();
  const dataList = useLoaderData("root"); 
  const [tableData, setTableData] = useState({
    columns: [],
    data: [],
  });
  const [chartData, setChartData] = useState({
    data: [],
  });

  const [loading, setLoading] = useState(false);
  const [filterValues, setFilterValues] = useState(initialValues);

  const onClearFilterValues = () => {
    setFilterValues(() => initialValues);
  };

  const onGetReportData = async () => {
    try {
      setLoading(true);
      console.log(filterValues);
      const res = await DefaultApiService.postApi(
        "DG/Management/StationSearch/GetData",
        filterValues
      );

      setLoading(false);
      // Make Table Data
      if (res?.data?.tableData) {
        const table = res?.data?.tableData;

        const tableColumns = table.columns.map((x) => ({
          id: x,
          label: x,
        }));
        const tableData = table.data.map((row, index) => {
          let item = {};

          for (let i = 0; i < row.length; i++) {
            item[table.columns[i]] = row[i];
          }
          return item;
        });

        setTableData((old) => ({
          ...old,
          columns: tableColumns,
          data: tableData,
          title: table?.title,
        }));
      }

      // Make Chart Data
      if (res?.data?.chartData) {
        const chart = res?.data?.chartData;
        let finalChartData = [];

        finalChartData = chart.xValues.map((item) => ({ x: item }));

        for (let i = 0; i < chart.data.length; i++) {
          const yData = chart.data[i];
          const sereTitle = chart.seriesTitle[i];

          for (let j = 0; j < yData.length; j++) {
            finalChartData[j][sereTitle] = yData[j];
          }
        }

        // console.log("finalChartData", finalChartData);

        setChartData({
          ...chart,
          data: finalChartData,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");
      setLoading(false);
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <Button
                  variant="outlined"
                  color="warning"
                  startIcon={<SearchIcon />}
                  onClick={onGetReportData}
                  disabled={loading}
                >
                  جستجو
                  {loading && (
                    <CircularProgress
                      color="warning"
                      size={16}
                      sx={{ ml: 2 }}
                    />
                  )}
                </Button>
                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />
                <Button
                  variant="text"
                  color="gray"
                  startIcon={<HighlightOffIcon />}
                  onClick={onClearFilterValues}
                >
                  حذف فیلترها
                </Button>
              </Box>
            }
          />
          <CardContent>
            <Grid container>
              {/* Filter Section */}
              <Grid container item xs={12} md={12} className="filter-bar">
                <Grid item container xs={12} md={12} spacing={2}>
                  <Grid item xs={12} md={4} lg={2}>
                    <DropdownPicker
                      label="جستجو بر اساس"
                      value={filterValues.SearchKind}
                      onChange={(event) => {
                        const value = event.target.value;
                        setFilterValues((old) => ({
                          ...old,
                          SearchKind: value,
                        }));
                      }}
                      list={dataList.searchKind || []}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={2}>
                    <TextField
                      label="متن جستجو"
                      type="string"
                      value={filterValues.SearchText}
                      onChange={(event) => {
                        const value = event.target.value;
                        setFilterValues((old) => ({
                          ...old,
                          SearchText: value,
                        }));
                      }}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Data */}
              <ReportDataShow
                tableData={tableData}
                chartData={chartData}
                loading={loading}
                hasExportPdf={useCheckPermission("pdf")}
                hasExportExcel={useCheckPermission("excel")}
                exportApi={pageInfo.link}
                filterValues={filterValues}
              />
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default StationSearchPage;
